<template>
  <div>
    <!-- Table -->
    <el-table v-if="!isTabLoading" :data="data" style="width: 100%">
      <el-table-column
        v-for="[key, value] of Object.entries(tableStructure)"
        :key="key"
        :prop="key"
        :label="value.label"
        :min-width="value.minWidth"
      >
        <template #header>
          <div v-if="value.tooltip" class="header-tooltip">
            <el-tooltip class="item" effect="dark" :content="value.toolContent" placement="top">
              <span>{{ value.label }} <i
                class="icon-filled-info"
                aria-hidden="true"
              /></span>
            </el-tooltip>
          </div>
          <div v-else>
            {{ value.label }}
          </div>
        </template>
        <template slot-scope="scope">
          <div v-if="key === 'InvoiceDate'" class="regular">
            <pre>{{ scope.row.Invoice?.IssuedDate ? $newFormatDate(scope.row.Invoice.IssuedDate, 'yyyy/MM/dd') : '' }}</pre>
          </div>
          <div v-else-if="key === 'InvoiceSn'" class="regular">
            <pre>{{ scope.row.Invoice?.SerialNumber || '' }}</pre>
          </div>
          <div v-else-if="key === 'TotalChargingKWH'" class="regular">
            <pre>{{ scope.row.TotalChargingKWH.toFixed(2) || 0 }}</pre>
          </div>
          <div v-else class="regular">
            <pre>{{ scope.row[key] }}</pre>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('EvCharging.Action')" width="120">
        <template slot-scope="scope">
          <div class="operate">
            <el-button size="mini" @click="$emit('download', scope.row.Period)">
              {{ actionName }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 表格內容loading 避免他會有標頭轉換跳轉閃爍問題，用 skeleton 當轉換效果 -->
    <el-skeleton v-if="isTabLoading" animated style="width: 100%;">
      <template #template>
        <div class="skeleton-table">
          <div class="skeleton-header">
            <div v-for="index in columnCount" :key="'header-' + index" class="skeleton-header-cell"></div>
          </div>
          <div v-for="rowIndex in rowCount" :key="'row-' + rowIndex" class="skeleton-row">
            <div
              v-for="colIndex in columnCount"
              :key="'row-' + rowIndex + '-col-' + colIndex"
              class="skeleton-cell"
            ></div>
          </div>
        </div>
      </template>
    </el-skeleton>
    <TableLoading v-if="!isTabLoading" :is-loading="loading" />
  </div>
</template>

<script>
import TableLoading from '@/components/TableLoading'

export default {
  components: {
    TableLoading
  },
  props: {
    actionName: {
      type: String,
      required: true
    },
    tableStructure: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    isTabLoading: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      // for skeleton row and column
      rowCount: 5,
      columnCount: 1
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table {
    @include basicTable(false);
    margin-top: 10px;
    margin-bottom: 17px;
}

.skeleton-table {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
}
.skeleton-header {
  display: flex;
  gap: 8px;
}
.skeleton-header-cell {
  flex: 1;
  height: 24px;
  background-color: $bgDark2;
  border-radius: 4px;
}
.skeleton-row {
  display: flex;
  gap: 8px;
}
.skeleton-cell {
  flex: 1;
  height: 20px;
  background-color:  $bgDark4;
  border-radius: 4px;
}
</style>
